import { Offer as OfferAPI } from '@occc-app/Activate/apiTypes';
import { deserializeDate } from '@occc-app/lib/deserializeDate';

import { MetaData } from './types';

type DeserializeOffer = (offerBody: OfferAPI) => MetaData;
export const deserializeOffer: DeserializeOffer = (offerBody) => {
  return {
    expireAt: deserializeDate(offerBody.attributes.expire_at),
    fulfillmentCount: offerBody.attributes.fulfillment_count,
    offerId: offerBody.id!,
    publishAt: deserializeDate(offerBody.attributes.publish_at),
  };
};
